module.exports = __webpack_public_path__ + "img/dataIcon-blue.84fa87be.svg";